export const Charity = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 28">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
      d="M15.094 27.003s18.029-15.037 13.03-22.804c-5.215-6.62-11.945-1.086-13.03 0-1.087-1.086-7.945-6.587-13.031 0-5.644 8.792 13.03 22.804 13.03 22.804Z"
    />
    <path
      fill="currentColor"
      d="M5.749 6.154c.473-.474.986-.794 1.54-.963a3.008 3.008 0 0 1 1.685-.025c.569.153 1.118.494 1.648 1.023l-1.12.879c-.433-.433-.914-.65-1.443-.65-.53 0-1.003.209-1.42.626-.425.425-.634.914-.626 1.468.008.553.237 1.055.686 1.505l1.828 1.828 2.42-2.419.866.867-2.419 2.419 1.624 1.624c.337.337.566.702.687 1.095l.01.037 4.093-4.093.926.926-5.8 5.8-.927-.926.313-.313c.168-.168.242-.385.218-.65a1.108 1.108 0 0 0-.338-.697L8.396 13.71l-.927.927-.867-.867.927-.926L5.7 11.014c-.489-.49-.81-1.019-.962-1.588a2.982 2.982 0 0 1 .036-1.698c.168-.569.493-1.094.975-1.575Z"
    />
  </svg>
)
